// extracted by mini-css-extract-plugin
export default {"root":"ShowMore_root__LY2I0","link":"ShowMore_link__ilpTi"};